import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatOptionModule } from '@angular/material/core';
import {UzurvPipesModule} from '@uzurv/core';
import { GenericAutocompleteResultsComponent } from './generic-autocomplete-results.component';

@NgModule({
  imports: [CommonModule, MatOptionModule, UzurvPipesModule],
  exports: [GenericAutocompleteResultsComponent],
  declarations: [GenericAutocompleteResultsComponent]
})
export class GenericAutocompleteResultsModule {}
